module.exports = __webpack_public_path__ + "img/yh_logo.72132d8a.png";